<section
    class="tw-bg-[#F7F7F7] tw-py-10 tw-px-[25px] md:tw-px-[30px] xl:tw-px-0"
>
    <div class="tw-max-w-[1280px] tw-mx-auto tw-items-center">
        <h2
            class="!tw-text-[22px] tw-text-center md:tw-text-left md:!tw-text-[28px] tw-w-full tw-text-[#0F3172] !tw-mb-[30px] !tw-font-bold"
        >
            {{ "DIGITAL_SERVICES.BUKKU.PRICING.TITLE" | translate }}
        </h2>
        <p
            class="tw-text-[#1A202C] !tw-text-sm !tw-text-center md:!tw-text-left !tw-mb-5"
        >
            {{ "DIGITAL_SERVICES.BUKKU.PRICING.DESC" | translate }}
        </p>

        <div
            class="tw-hidden sm:tw-grid md:tw-grid-cols-2 lg:tw-grid-cols-5 tw-gap-5 tw-justify-center"
        >
            <div
                *ngFor="let item of servicesData"
                class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center tw-w-full tw-h-[289px]"
            >
                <img
                    [src]="item.img"
                    alt="Financing Options"
                    class="tw-mx-auto tw-mb-4 tw-h-[48px] tw-w-[48px] sm:tw-h-[84px] sm:tw-w-[84px]"
                />
                <p
                    [innerHTML]="item.title | translate"
                    class="tw-font-bold tw-text-lg tw-mb-2 !tw-text-[20px] sm:!tw-text-[16px] tw-leading-[20px]"
                ></p>
                <p class="tw-text-black-600 !tw-text-[14px] sm:!tw-text-[13px]">
                    {{ item.desc | translate }}
                </p>
            </div>
        </div>
        <div class="tw-block sm:tw-hidden">
            <div
                class="tw-max-w-[300px] tw-mx-auto tw-w-full tw-overflow-hidden"
            >
                <ngx-slick-carousel
                    class="carousel p-n-s what-new"
                    [config]="slideConfig"
                >
                    <div
                        *ngFor="let item of servicesData"
                        ngxSlickItem
                        class="tw-bg-white tw-rounded-2xl tw-p-7 tw-text-center tw-w-full tw-max-w-[300px] !tw-max-h-[224px] !tw-mr-[20px]"
                    >
                        <img
                            [src]="item.img"
                            alt="Seamless Application"
                            class="tw-mx-auto tw-mb-4 tw-h-[48px] tw-w-[48px] sm:tw-h-[84px] sm:tw-w-[84px]"
                        />

                        <p
                            [innerHTML]="item.title | translate"
                            class="tw-font-bold tw-text-lg tw-mb-2 !tw-text-[14px] tw-leading-[20px]"
                        >1111</p>
                        <p class="tw-text-black-600 !tw-text-[13px]">
                            {{ item.desc | translate }}
                        </p>
                    </div>
                </ngx-slick-carousel>
            </div>
        </div>
    </div>
</section>
